import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { productViewAction } from "../../redux/actions/product-action";
import ViewEditProduct from "../../components/product-information/product-view-edit";
const ViewProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(productViewAction(id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setProduct(data?.data?.[0]);
  };
  const onError = (data) => {
    loading(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          page="view"
          title="View Product"
          // title1={product?.item_code}

          view={true}
          onclkEditFn={() => navigate(`/edit-product/${id}`)}
        >
          <ViewEditProduct product={product} disabled={true} page="view" />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewProduct;
